import { render, staticRenderFns } from "./SystemContainer.vue?vue&type=template&id=1f1f8676&scoped=true"
import script from "./SystemContainer.vue?vue&type=script&lang=js"
export * from "./SystemContainer.vue?vue&type=script&lang=js"
import style0 from "./SystemContainer.vue?vue&type=style&index=0&id=1f1f8676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1f8676",
  null
  
)

export default component.exports